import type { ReactNode } from 'react'
import { TrayIcon, type Icon as PhosphorIcon } from '@phosphor-icons/react'
import { Icon } from '@/components/ui/Icon'
import { cn } from '@/lib/cn'
import styles from './EmptyState.module.css'

type EmptyStateProps = {
  title: string
  className?: string
  description?: string
  action?: ReactNode
  icon?: PhosphorIcon
  artwork?: ReactNode
  artworkPresentation?: 'icon' | 'illustration'
  image?: string
  imageAlt?: string
  density?: 'default' | 'compact'
}

export function EmptyState({ title, className, description, action, icon = TrayIcon, artwork, artworkPresentation = 'icon', image, imageAlt = '', density = 'default' }: EmptyStateProps) {
  return <section className={cn(styles.root, { [styles.compact]: density === 'compact' }, className)} role="status">
    <span className={`${styles.artwork} ${image ? styles.imageArtwork : artworkPresentation === 'illustration' ? styles.illustrationArtwork : ''}`} aria-hidden={imageAlt ? undefined : true}>{image ? <img src={image} alt={imageAlt} /> : artwork ?? <Icon as={icon} size={48} weight="light" />}</span>
    <div className={styles.copy}>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  </section>
}
